import * as React from "react";
import {
  Header,
  Segment,
  Form,
  Grid,
  Message,
  Loader,
  Dimmer,
} from "semantic-ui-react";
import { Formik, Field, FieldProps } from "formik";
import {
  GenerateDataFormModel,
  DataAmount,
  DataLevel,
  generateUsers,
  UserData,
} from "../func/generateUsers";
import TestingView from "./TestingView";
import PreviewView from "./PreviewView";

export default function TryNowSection() {
  const [users, setUsers] = React.useState<UserData>();
  const [loading, setLoading] = React.useState<boolean>(false);
  const [generatorConfig, setGeneratorConfig] = React.useState<
    GenerateDataFormModel | undefined
  >();
  return (
    <>
      <Header as="h1" id="demo">
        Demo
      </Header>
      <Segment>
        <Header as="h3">Generate Data</Header>
        <Formik<GenerateDataFormModel>
          initialValues={{ amount: DataAmount["10k"], level: DataLevel.Single }}
          onSubmit={async form => {
            setGeneratorConfig(form);
            setLoading(true);
            await new Promise<any>(resolve => setTimeout(resolve, 100));
            const users = await generateUsers(form);
            setUsers(users);
            setLoading(false);
          }}
        >
          {({ submitForm }) => (
            <Form>
              <Form.Group widths="equal">
                <Field
                  name="amount"
                  render={({
                    field,
                    form,
                  }: FieldProps<GenerateDataFormModel>) => (
                    <Form.Select
                      fluid
                      label="Amount"
                      options={[
                        {
                          key: DataAmount["10k"],
                          text: DataAmount["10k"],
                          value: DataAmount["10k"],
                        },
                        {
                          key: DataAmount["50k"],
                          text: DataAmount["50k"],
                          value: DataAmount["50k"],
                        },
                        {
                          key: DataAmount["100k"],
                          text: DataAmount["100k"],
                          value: DataAmount["100k"],
                        },
                        {
                          key: DataAmount["250k"],
                          text: DataAmount["250k"],
                          value: DataAmount["250k"],
                        },
                        {
                          key: DataAmount["500k"],
                          text: DataAmount["500k"],
                          value: DataAmount["500k"],
                        },
                      ]}
                      onChange={(event, dropdownProps) =>
                        form.setFieldValue("amount", dropdownProps.value)
                      }
                      value={field.value}
                    />
                  )}
                />
                <Field
                  name="level"
                  render={({
                    field,
                    form,
                  }: FieldProps<GenerateDataFormModel>) => (
                    <Form.Select
                      fluid
                      label="Level"
                      options={[
                        {
                          key: DataLevel.Single,
                          text: "Single Level",
                          value: DataLevel.Single,
                        },
                        {
                          key: DataLevel.TwoLevel,
                          text: "Two Level",
                          value: DataLevel.TwoLevel,
                        },
                      ]}
                      onChange={(event, dropdownProps) =>
                        form.setFieldValue("level", dropdownProps.value)
                      }
                      value={field.value}
                    />
                  )}
                />
                <Form.Field>
                  <label>.</label>
                  <Form.Button fluid primary onClick={submitForm}>
                    Generate
                  </Form.Button>
                </Form.Field>
              </Form.Group>
            </Form>
          )}
        </Formik>
      </Segment>
      <Grid>
        <Grid.Row>
          <Grid.Column computer="10" tablet="10" mobile="16">
            <Segment>
              <Header as="h3">Benchmark</Header>
              <Dimmer active={loading} inverted>
                <Loader />
              </Dimmer>
              {!loading && users && generatorConfig ? (
                <TestingView users={users} generatorConfig={generatorConfig} />
              ) : (
                <Message warning>Please Generate Data</Message>
              )}
            </Segment>
          </Grid.Column>
          <Grid.Column computer="6" tablet="6" mobile="16">
            <Segment>
              <Header as="h3">
                Preview Generated Data
                {!loading && users ? (
                  <Header.Subheader>{`Length: ${users.length}`}</Header.Subheader>
                ) : null}
              </Header>
              <Dimmer active={loading} inverted>
                <Loader />
              </Dimmer>
              {!loading && users ? (
                <PreviewView users={users} />
              ) : (
                <Message warning>Please Generate Data</Message>
              )}
            </Segment>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </>
  );
}
